import { getSafeStoreInfoRequestContext } from '../context';

/**
 * Проверяет, является ли текущий магазин магазином с внешним чекаутом.
 *
 * @returns Признак магазина с внешним чекаутом.
 * @kind helper
 */
export function checkIsExternalCheckout(): boolean {
    return getSafeStoreInfoRequestContext().isExternalCheckout;
}
